import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'input-money',
  templateUrl: './input-money.component.html',
  styleUrls: ['./input-money.component.scss', '../input.scss']
})
export class InputMoneyComponent {
  
  @Input() 
  public label: string = "Test";

  @Input()
  public inputValue: string = "";

  @Input()
  public readonly = false;

  @Output()
  public save = new EventEmitter<number>();

  constructor() {

  }

  saveAmount(){
    const numeric = typeof this.inputValue === 'string' ? parseFloat(this.inputValue as any) : (this.inputValue as any);
    this.save.emit(isNaN(+numeric) ? 0 : +numeric);
  }
}
